import "pages/explore-the-archive/image/image.js";

// Load styles.
import "./image.scss";



// WEBPACK FOOTER //
// ./src/frontend/entry-points/image/image.js